import { inject, Injectable } from '@angular/core';
import { IsoDateTimeTz, IsoTimeOffset } from '../types/iso-date';
import { TimeZoneService } from './time-zone.service';
import { AbstractDateService } from './abstract-date.service';
import { isIsoDateTimeTz } from '../functions/validation/is-iso-date-time-tz.function';
import { toIsoDateTimeTz } from '../functions/manupulation/conversion/to-iso-date-time-tz.function';

@Injectable({ providedIn: 'root' })
export class DateTimeTzService extends AbstractDateService<IsoDateTimeTz> {

  timeZoneService = inject(TimeZoneService);

  override now(): IsoDateTimeTz {
    const now = new Date();
    const timeZone = this.timeZoneService.timeZone();
    toIsoDateTimeTz(now, timeZone);
    return toIsoDateTimeTz(now, timeZone) as IsoDateTimeTz;
  }

  override isValid(date: string): date is IsoDateTimeTz {
    return isIsoDateTimeTz(date);
  }
}
